import { randomId } from '../lib-randomId';
/**
 * Assign id if it is not already set.
 */
export function assignAndGetId(target) {
    var id = target.getAttribute('id');
    if (!id) {
        id = randomId();
        target === null || target === void 0 ? void 0 : target.setAttribute('id', id);
    }
    return id;
}
